module.exports = __webpack_public_path__ + "img/cc358ac.jpg";